<template>
  <el-dialog
    class="excellent-capabilities-download-dialog common-dialog"
    :title="title"
    :visible.sync="showDialog"
    :lock-scroll="true"
    :show-close="!downloading"
    :top="top"
  >
    <div>
      <span v-if="downloading">{{ `正在下载 ${fileName}` }}</span>
      <span v-else>
        <el-form
          ref="abilitySelectForm"
          class="ability-select-form"
          :model="abilitySelectForm"
          :label-width="`${adaptationVars.formLabelWidth}px`"
          :rules="abilitySelectRules"
        >
          <el-form-item :label="'增强能力选择'" prop="ability">
            <el-select
              v-model="abilitySelectForm.ability"
              multiple
              placeholder="请选择要部署的增强能力"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </span>
    </div>
    <span slot="footer">
      <el-button :disabled="downloading" @click="cacel">{{ cancelText }}</el-button>
      <el-button
        type="primary"
        :disabled="downloading"
        :loading="downloading"
        @click="startDownload()"
        >{{ sureText }}</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'DownloadDialog',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 100
  },
  props: {
    dialogVisible: Boolean,
    title: {
      type: String,
      default: '下载'
    },
    sureText: {
      type: String,
      default: '确 定'
    },
    cancelText: {
      type: String,
      default: '取 消'
    },
    top: {
      type: String,
      default: '40vh'
    },
    fileUrl: {
      type: String,
      default: ''
    },
    fileName: {
      type: String,
      default: ''
    },
    storeFileName: {
      type: Function,
      default: undefined
    },
    metaData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      downloading: false,
      showDialog: false,
      adaptationVars: {
        formLabelWidth: 100
      },
      abilitySelectForm: {
        ability: []
      },
      abilitySelectRules: {
        ability: [
          {
            type: 'array',
            required: true,
            min: 1,
            message: '至少选择一项增强能力',
            trigger: 'change'
          }
        ]
      },
      options: [
        {
          value: 1,
          label: '多方安全计算'
        },
        {
          value: 2,
          label: '密文检索'
        },
        {
          value: 3,
          label: '属性加密'
        }
      ]
    }
  },
  watch: {
    dialogVisible: function(val) {
      this.showDialog = val
    },
    showDialog: function(val) {
      this.$emit('update:dialogVisible', val)
    },
    chainId: function(val) {
      console.log(val)
    }
  },
  methods: {
    cacel() {
      this.showDialog = false
      this.downloading = false
    },
    startDownload() {
      let self = this
      this.$refs.abilitySelectForm.validate(async valid => {
        if (valid) {
          self.downloading = true
          let filename = self.fileName
          let fileUrl = self.fileUrl
          new Promise(async (resolve, reject) => {
            try {
              await self.downloadFile(filename, fileUrl)
              self.$message.success('下载成功')
              self.showDialog = false
              self.downloading = false
              resolve(true)
            } catch (err) {
              let msg = `下载 ${filename} 失败：${err.message}`
              self.$message.warning(msg)
              self.showDialog = false
              self.downloading = false
              console.log(msg)
            }
          })
            .then(data => {
              console.log('下载完成')
            })
            .catch(err => {
              let msg = `下载 ${filename} 失败：${err}`
              self.$message.warning(msg)
              self.showDialog = false
              self.downloading = false
              console.log(msg)
            })
        } else {
          self.$message.warning('至少选择一项增强能力')
        }
      })
    },
    downloadFile(fileName, fileUrl) {
      let self = this
      return new Promise((resolve, reject) => {
        const baseUrl = self.g_Config.BASE_URL + fileUrl
        const userInfoStr = localStorage.getItem('cbaas_system_userInfo')
        const userInfo = userInfoStr ? JSON.parse(userInfoStr) : {}
        let tabObjObj = {}
        tabObjObj.username = userInfo.username
        tabObjObj.roleID = userInfo.roleID
        tabObjObj.roleName = userInfo.roleName
        tabObjObj.encryptsvrs = self.abilitySelectForm.ability
        let params = JSON.stringify(tabObjObj)
        let xhr = new XMLHttpRequest()
        xhr.open('post', baseUrl, true)
        xhr.responseType = 'blob' // 转换流
        xhr.setRequestHeader(
          'Authorization',
          'Bearer ' + localStorage.getItem('cbaas_system_Token')
        )
        xhr.onload = function() {
          if (xhr.status === 200) {
            try {
              let blob = xhr.response
              let a = document.createElement('a')
              let url = window.URL.createObjectURL(blob)
              a.href = url
              a.download = self.storeFileName ? self.storeFileName(xhr, self.metaData) : fileName // 文件名
              a.click()
              window.URL.revokeObjectURL(url)
              resolve(true)
            } catch (err) {
              reject(err)
            }
          } else {
            reject('status: ' + xhr.status + '\n response: ' + xhr.response)
          }
        }
        xhr.send(params)
      })
    }
  }
}
</script>
<style scoped lang="scss">
.excellent-capabilities-download-dialog.common-dialog {
  /deep/ .el-dialog {
    width: var(--common-dialog-large-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);

    .el-select {
      width: 100%;
    }

    /deep/ .el-form-item__content {
      display: flex;
    }
  }
}
</style>
